import companyCodesColumnDefinition from '../../shared/columnDefinitions/companyCodes';
import businessUnitsColumnDefinition from '../../shared/columnDefinitions/businessUnits';
import { legalEntitiesWithSourceColumnDefinitions } from '../../shared/columnDefinitions/legalEntities';
import { getBookToTaxDifferencesColumnDefinitions, bookToTaxDifferencesColumnDefintionsForImport } from '../../shared/columnDefinitions/bookToTaxDifferences';
import taxRatesColumnDefinition from '../../shared/columnDefinitions/taxRates';
import obligationsColumnDefinition from '../../shared/columnDefinitions/obligations';
import taxBookingEntitiesColumnDefinition from '../../shared/columnDefinitions/taxBookingEntities';
import tlsAccountsWithTagsColumnDefinitions from '../../shared/columnDefinitions/tlsAccounts';
import taxAccountingColumnDefinition from '../../shared/columnDefinitions/taxAccounting';
import usersColumnDefinition from '../../shared/columnDefinitions/users';
import subledgerMapColumnDefinition from '../../shared/columnDefinitions/glJournals';
import currencyColumnDefinition from '../../shared/columnDefinitions/currency';
import periodsColumnDefinitions from '../../shared/columnDefinitions/periods';
import currencyConversionRateColumnDefinitions from '../../shared/columnDefinitions/currencyConversionRates';

import { PillTypes } from './constants';

export const ConfigurationColumnDefinitions = {
  companyCodesColumnDefinition,
  businessUnitsColumnDefinition,
  legalEntitiesWithSourceColumnDefinitions,
  bookToTaxDifferencesColumnDefinition: bookToTaxDifferencesColumnDefintionsForImport,
  taxRatesColumnDefinition,
  obligationsColumnDefinition,
  taxBookingEntitiesColumnDefinition,
  tlsAccountsWithTagsColumnDefinitions: categories => tlsAccountsWithTagsColumnDefinitions(categories),
  taxAccountingColumnDefinition,
  usersColumnDefinition,
  subledgerMapColumnDefinition,
  currencyColumnDefinition,
  periodsColumnDefinitions,
  currencyConversionRateColumnDefinitions,
};

export default ({ countryTaxTypes, categories }) => ({
  [PillTypes.COMPANY_CODES]: companyCodesColumnDefinition,
  [PillTypes.BUSINESS_UNITS]: businessUnitsColumnDefinition,
  [PillTypes.LEGAL_ENTITIES]: legalEntitiesWithSourceColumnDefinitions,
  [PillTypes.BOOK_TO_TAX_DIFFERENCES]:
    getBookToTaxDifferencesColumnDefinitions({ countryTaxTypes, viewOnly: true }),
  [PillTypes.TAX_RATES]: taxRatesColumnDefinition,
  [PillTypes.OBLIGATIONS]: obligationsColumnDefinition,
  [PillTypes.TAX_BOOKING_ENTITIES]: taxBookingEntitiesColumnDefinition,
  [PillTypes.TLS_ACCOUNTS]: tlsAccountsWithTagsColumnDefinitions(categories),
  [PillTypes.TAX_ACCOUNTING]: taxAccountingColumnDefinition,
  [PillTypes.USERS]: usersColumnDefinition,
  [PillTypes.SUBLEDGER_MAP]: subledgerMapColumnDefinition,
  [PillTypes.CURRENCY]: currencyColumnDefinition,
  [PillTypes.PERIODS]: periodsColumnDefinitions,
  [PillTypes.CURRENCY_CONVERSION_RATES]: currencyConversionRateColumnDefinitions,
});
